import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "filters-row" }
const _hoisted_2 = {
  key: 1,
  class: "text-grey text-caption"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RequestsFilters',
  props: {
    searchQuery: {},
    filterStatus: {},
    filterSchool: {},
    schoolOptions: {}
  },
  emits: ["update:searchQuery", "update:filterStatus", "update:filterSchool"],
  setup(__props: any, { emit: __emit }) {

/* eslint-disable no-undef */
const props = __props

const emit = __emit

const statusOptions = [
  { title: 'Pending', value: 'pending' },
  { title: 'Filled', value: 'filled' },
  { title: 'Completed', value: 'completed' },
  { title: 'Denied', value: 'denied' }
]

const removeStatus = (value: string) => {
  const newStatus = props.filterStatus.filter(s => s !== value)
  emit('update:filterStatus', newStatus)
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "filters-card mb-4" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_text_field, {
              "model-value": __props.searchQuery,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:searchQuery', $event))),
              placeholder: "Search by student name or school...",
              variant: "outlined",
              density: "compact",
              "prepend-inner-icon": "mdi-magnify",
              "hide-details": "",
              class: "search-box"
            }, null, 8, ["model-value"]),
            _createVNode(_component_v_select, {
              "model-value": __props.filterStatus,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:filterStatus', $event))),
              items: statusOptions,
              label: "Status",
              variant: "outlined",
              density: "compact",
              "hide-details": "",
              class: "filter-select",
              multiple: "",
              "menu-props": { maxHeight: 300 }
            }, {
              selection: _withCtx(({ item, index }) => [
                (index < 1)
                  ? (_openBlock(), _createBlock(_component_v_chip, {
                      key: 0,
                      size: "small",
                      closable: "",
                      "onClick:close": ($event: any) => (removeStatus(item.value))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick:close"]))
                  : _createCommentVNode("", true),
                (index === 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, " (+" + _toDisplayString(__props.filterStatus.length - 1) + " more) ", 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["model-value"]),
            _createVNode(_component_v_select, {
              "model-value": __props.filterSchool,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:filterSchool', $event))),
              items: __props.schoolOptions,
              label: "School",
              variant: "outlined",
              density: "compact",
              "hide-details": "",
              class: "filter-select"
            }, null, 8, ["model-value", "items"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})